import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Features, UserRole } from "../../Enums/companyStatus";
import { hasPermission, hasRole } from "../../Helpers/authHelpers";

type Props = {
  feature: Features;
  fallbackPath?: string;
};

const RequireFeature: React.FC<Props> = ({ feature, fallbackPath = "/home" }) => {
  if (hasRole(UserRole.ADMIN) || hasPermission(feature)) {
    return <Outlet />;
  }

  return <Navigate to={fallbackPath} replace />;
};

export default RequireFeature;
